var exports = {
  "Q": "x61f99309--f07b56--content",
};

module.exports = exports;
